module.exports = __webpack_public_path__ + "static/Fanen-5bdce19367fd67c297ac90f006fc5a9e.png";